module.exports = __webpack_public_path__ + "static/media/12.6238cc91.jpg";